import {svgIconWrapper} from '../svg-icon-wrapper';

import ChartLineUpRegular from './chart-line-up-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChartLineUpRegular {...validProps} />;
}

SvgComponent.iconName = 'chartLineUpRegular';

export const ChartLineUpRegularIcon = svgIconWrapper(SvgComponent);
